import React, { useContext, useEffect, useState } from "react";
// import { useDispatch } from "react-redux";
import { useGoogleLogin } from "react-google-login";
import * as Cookies from "js-cookie";
import { useHistory } from "react-router-dom";
import { SignupContext } from "src/context/SignupContext/SignupContext";
import Api from "src/network";
import SignUpRepo from "src/repo/signup_repo";
import { GoogleButton } from "./SocialButtons";
import DefaultCommModal from "./DefaultCommModal";
import * as SignInActions from "src/store/actions/SignInActions/SignInAction";
import { useDispatch, useSelector } from "react-redux";
import { extractCommunityInfo } from "../../../Utils/extractCommunityInfo";
import DefaultCommunityChangePage from "./SignIn/DefaultCommunityChangePage";
// import EmailVerificationModal from "./EmailVerification";

const clientId =
  "1096351929813-b3sqsgi9t95dfbr7jhsruvsfvh8q6iac.apps.googleusercontent.com";

const defaultState = {
  email: "",
  password: "",
  displayName: "",
  community: "Default Community",
  tenantId: "",
};

function GoogleSignUp(props) {
  const history = useHistory();
  const emailAction = useSelector((state) => state.emailActionReducer);
  const { invitedCommunityName, invitedCommunityId, invitedEmailId } =
    extractCommunityInfo(emailAction);
  const [loading, setLoading] = useState(false);
  const [showDefaultCommModal, setShowDefaultCommModal] = useState(false);
  const [state, setState] = useState({ ...defaultState });
  const [isUserBlocked, setIsUserBlocked] = useState(null);
  const [userDetails, setUserDetails] = useState(null);
  // const [verificationModal, setVerificationModal] = useState(false);
  // const [resendOtp, setResendOtp] = useState(false);

  // const dispatch = useDispatch();
  const signupContext = useContext(SignupContext);
  const dispatch = useDispatch();
  const SignInReducer = useSelector((state) => state.SignInReducer);
  const { isAuthenticating } = SignInReducer;

  useEffect(() => {
    const { googleSignUp, email, password, displayName, community, tenantId } =
      signupContext?.signupState;
    if (googleSignUp) {
      setState((prevState) => ({
        ...prevState,
        email: email,
        password: password,
        displayName: displayName,
        community: community,
        tenantId: tenantId,
      }));
      setShowDefaultCommModal(true);
    }
  }, []);

  const handleTenantBlockedLogic = (userDetails) => {
    const count = userDetails?.userData?.communityFollowNames?.length ?? 0;
    if (
      userDetails?.userData?.communityStatus === "communityBlocked" ||
      userDetails?.userData?.currentCommunityStatus == 0
    ) {
      if (count > 1) setIsUserBlocked(true);
      else if (count === 1) history.push("/defaultCommunity");
    }
  };

  const onCloseDefaultCommunitykModal = () => {
    setIsUserBlocked(false);
    if (
      userDetails?.userData?.communityStatus === "communityBlocked" ||
      userDetails?.userData?.currentCommunityStatus == 0
    ) {
      dispatch(SignInActions.signOut());
    }
  };

  const onSuccess = async (res) => {
    dispatch(SignInActions.setAuthenticating(true));
    console.log(res);
    const googleResponse = {
      name: res.profileObj.name,
      email: res.profileObj.email,
      tokenId: res.tokenId,
      accessToken: res.accessToken,
      givenName: res.profileObj.givenName,
      familyName: res.profileObj.familyName,
      imageUrl: res.profileObj.imageUrl,
    };
    console.log("googleResponse->", googleResponse);

    try {
      const result = await Api.validateGoogleToken(googleResponse.tokenId);
      const { status } = result?.data || {};
      if (
        status &&
        String(status).toLowerCase() ===
          "Thank you for SignUp using your Gmail account, Skopic has created a profile for you and a temporary Skopic password has been emailed.".toLowerCase()
      ) {
        signupContext?.setSignupState({
          googleSignUp: true, //set true to navigation purpose
          email: googleResponse?.email,
          password: "",
          displayName: googleResponse?.name,
          community: invitedCommunityName || "",
          tenantId: "",
        });
        setState({
          ...defaultState,
          email: googleResponse?.email,
          displayName: googleResponse?.name,
          community: invitedCommunityName || "",
        });
        setShowDefaultCommModal(true);
      } else if (
        status &&
        String(status).toLowerCase() ===
          "Thank you for Signing using your Gmail account".toLowerCase()
      ) {
        authenticate(
          result?.data?.userTenantId,
          result?.data?.userTenant,
          false,
        );
      }
    } catch (e) {
      console.error(e);
    }
  };

  const onFailure = (error) => {
    console.error("login failed: ", error);
    dispatch(SignInActions.setAuthenticating(false));
  };

  const { signIn } = useGoogleLogin({
    onSuccess,
    onFailure,
    clientId,
  });

  const onCloseModal = () => {
    setShowDefaultCommModal(false);
    dispatch(SignInActions.setAuthenticating(false));
    //reset all values
    setState({ ...defaultState });
    //reset signup context data
    signupContext?.resetSignupState();
  };

  const handleMakeDefault = async (tenantId) => {
    let formdata = new FormData();
    formdata.append("userDefaultTenantId", tenantId);
    setLoading(true);
    Api.setDefaultTenant(formdata)
      .then((res) => {
        console.log("handleMakeDefault res", res);
        setLoading(false);
        authenticate(tenantId, state?.community, true);
      })
      .catch((err) => {
        setLoading(false);
        alert("Default Community selection failed!");
      });
  };

  const isBtnDisabled = () => {
    return (
      !state?.community ||
      (state?.community).toLowerCase() === "default community" ||
      loading
    );
  };

  const onSignUp = async (tenantId) => {
    const finalTenantId = invitedCommunityId || tenantId;
    // if there is no community selected
    if (isBtnDisabled()) return;
    await handleMakeDefault(finalTenantId);
  };

  const authenticate = async (tenantId, community, isSignUpFlow) => {
    // if (isAuthenticating) return; // Prevent multiple clicks
    // dispatch(SignInActions.setAuthenticating(true)); // Disable all buttons
    try {
      setLoading(true);
      const finalCommunity = invitedCommunityName || community;
      const blockedTenants = ["tenant_blocked", "Inactive Tenant"];
      const updatedCommunity = blockedTenants.includes(finalCommunity)
        ? ""
        : finalCommunity;
      const finalTenantId = invitedCommunityId || tenantId;
      await Api.getUserData(finalTenantId, updatedCommunity);
      if (
        finalCommunity === "tenant_blocked" ||
        finalCommunity === "Inactive Tenant"
      ) {
        const res = await Api.fetchLoginUser();
        setUserDetails(res?.data);
        handleTenantBlockedLogic(res?.data);
      }
      setTimeout(async () => {
        if (invitedCommunityId && invitedCommunityName) {
          const formdata = new FormData();
          formdata.append("communityID", invitedCommunityId);
          formdata.append("communityName", invitedCommunityName);
          formdata.append("followStat", 1); // 1 means follow
          formdata.append("sourceApp", "WebApp");

          await Api.followUnfollowCommunity(formdata);
        }
      }, 500);
      // set cookies
      if (finalCommunity !== "tenant_blocked" && finalCommunity !== "Inactive Tenant") {
        Cookies.set("signInStatus", true);
        history.push("/Home");
      }
      // sessionStorage.setItem("userData", JSON.stringify(result));

      if (isSignUpFlow) {
        //for signup flow
        // close default community selection popup
        setShowDefaultCommModal(false);
        // reset signup context data
        signupContext?.resetSignupState();
        // set isNewUser flag to true
        dispatch(SignInActions?.updateIsNewUser(true));
      }

      dispatch(SignInActions.authUser());
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
      dispatch(SignInActions.setAuthenticating(false));
    }
  };

  return (
    <>
      <GoogleButton
        onClick={() => {
          console.log("CLICKED Continue with Google BUTTON");
          signIn();
          dispatch(SignInActions.setAuthenticating(true));
        }}
        loading={loading}
        isAuthenticating={isAuthenticating}
      />
      {showDefaultCommModal && (
        <DefaultCommModal
          open={showDefaultCommModal}
          onClose={onCloseModal}
          loading={loading}
          email={state?.email}
          password={state?.password}
          community={state?.community}
          tenantId={invitedCommunityId || state?.tenantId}
          displayName={state?.displayName}
          onSignUp={onSignUp}
          disabled={isBtnDisabled()}
          invitedCommunityName={invitedCommunityName}
        />
      )}

      <DefaultCommunityChangePage
        isUserBlocked={isUserBlocked}
        onCloseDefaultCommunitykModal={onCloseDefaultCommunitykModal}
        userDetails={userDetails}
      />

      {/* <EmailVerificationModal
        centered
        show={verificationModal}
        onHide={() => setVerificationModal(false)}
        dispatch={dispatch}
        email={state?.email}
        tentId={state?.tenantId}
        password={state?.password}
        tenantName={state?.community}
        resendOtp={resendOtp}
      /> */}
    </>
  );
}

export default GoogleSignUp;
